import { useState, useEffect, useCallback } from "react";
import { useIsMobile } from '../../hooks/useIsMobile';
import api from "../../api/api";
import { Server } from '../../utils/config';

const Phase1 = (props) => {
  const [error, setError] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false)

  const handleGameStateChanged = props.handleGameStateChanged
  const handleSetStale = props.handleSetStale
  const handleSetStaleParticipants = props.handleSetStaleParticipants
  const handleSetParticipantGameCode = props.handleSetParticipantGameCode
  const handleSetParticipantName = props.handleSetParticipantName

  const maxParticipants = 10;
  const isMobile = useIsMobile();

  const addParticipantSlots = useCallback(() => {
      return (
        <>
          {props.gameParticipants?.map((participant) => {
              return <div key={participant["$id"]} className="p-1 my-2 border border-black text-black font-bold text-center">{participant["Name"]}</div>
            })
          }

          {[...Array(maxParticipants)].map((_, num) => {
            return (num > (props.gameParticipants?.length || 0)) &&
              <div key={num} className="p-1 my-2 border border-black text-gray-500 text-center">Login to play!</div>
            }
          )}
        </>
      )
    }, [props.gameParticipants]
  );

  useEffect(() => {
    if (!!(props.gameCode && localStorage.getItem('participantName')) && localStorage.getItem('gameCode') !== props.gameCode) {
      localStorage.removeItem('participantName')
      localStorage.removeItem('gameCode')
    }
  }, [formSubmitted, props.participantName])

  useEffect(() => {
    const timer = setTimeout(() => {
        handleSetStale();
    }, 5000);
  }, [props.gameParticipants, handleSetStale]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (props.gameParticipants.length >= maxParticipants - 1) {
      setError("Game is full - try again later")
      handleGameStateChanged({newPhase: 2})
    }

    if (props.gameCode === props.participantGameCode) {
      const data = {
        GameCode: props.participantGameCode,
        Name: props.participantName,
        Deleted: false,
      };
      try {
        localStorage.setItem('participantName', props.participantName)
        localStorage.setItem('gameCode', props.participantGameCode)
        await api.createDocument(
          Server.gameParticipantsCollectionId,
          data
        )
        .then( async (document) => {
          setFormSubmitted(true)
          if (props.gameParticipants.length >= maxParticipants - 1) {
            handleGameStateChanged({newPhase: 2})
          }
        }, error => {
          setError(error.toString())
          setTimeout(() => {
            setError(null)
          }, 5000);
        });
      } catch (e) {
        console.log("Error adding game participant", e);
        localStorage.removeItem('participantName')
        localStorage.removeItem('gameCode')
      }
    } else {
      setError("Incorrect game code.  Try again")
      const timer = setTimeout(() => {
        setError('')
        clearTimeout(timer)
      }, 6000);
    }
  };

  const loadTeamSlots = useCallback(() => {
    return (
      <div className="mx-auto w-[70%] border border-black rounded-xl p-4 mt-14">
        <h3 className="relative right-6 bottom-6 bg-gradient-to-r rounded-xl p-1 from-cyan-500 to-blue-500 text-white text-center">Teams</h3>
        {addParticipantSlots(isMobile)}
      </div>
    )
  }, [addParticipantSlots, isMobile]);

  if (props.gameCode !== '' && props.gameCode !== undefined && props.gameCode !== null) {
    return (
      isMobile ? (
        <div className="flex flex-col">

          {loadTeamSlots()}

          <div className="w-[70%] mx-auto items-center justify-center justify-items-center mt-8 mb-6">
            <div className="text-xl text-red-900">{error}</div>
            <form onSubmit={handleSubmit}>
              <label className="block mt-6"> Game Code</label>
              <input
                className="p-1 placeholder-gray-400 text-gray-700 bg-white text-lg border border-1 border-b-2 border-gray-400 focus:ring-0 focus:border-gray-900"
                type="text"
                onChange={(e) => handleSetParticipantGameCode(e.target.value)}
              />
              <label className="block mt-6"> Team Name</label>
              <input
                className="p-1 placeholder-gray-400 text-gray-700 bg-white text-lg border border-1 border-b-2 border-gray-400 focus:ring-0 focus:border-gray-900"
                type="text"
                onChange={(e) => handleSetParticipantName(e.target.value)}
              />

              <div className="mt-6">
                <button
                  type="submit"
                  disabled={!props.participantGameCode || !props.participantName}
                  className="mx-auto mt-4 py-4 px-16 font-semibold rounded-lg shadow-md bg-gray-900 text-white border hover:border-gray-900 hover:text-gray-900 hover:bg-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Play
                </button>
              </div>
            </form>
          </div>

        </div>

      ) : (
        <div className="flex flex-row">
          <div className="basis-3/4 ml-20 mt-64">
            <div className="text-xl text-red-900 mr-10">{error}</div>
            <form onSubmit={handleSubmit}>
              <label className="block mt-6"> Game Code</label>
              <input
                className="p-1 right-10 placeholder-gray-400 text-gray-700 bg-white text-lg border border-1 border-b-2 border-gray-400 focus:ring-0 focus:border-gray-900"
                type="text"
                onChange={(e) => handleSetParticipantGameCode(e.target.value)}
              />
              <label className="block mt-6"> Your Name</label>
              <input
                className="p-1 right-10 placeholder-gray-400 text-gray-700 bg-white text-lg border border-1 border-b-2 border-gray-400 focus:ring-0 focus:border-gray-900"
                type="text"
                onChange={(e) => handleSetParticipantName(e.target.value)}
              />

              <div className="mt-6">
                <button
                  type="submit"
                  disabled={!props.participantGameCode || !props.participantName}
                  className="mx-auto mt-4 py-4 px-16 font-semibold rounded-lg shadow-md bg-gray-900 text-white border hover:border-gray-900 hover:text-gray-900 hover:bg-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Play
                </button>
              </div>
            </form>
          </div>

          <div className="basis-1/4 border border-black rounded-xl p-4 mr-12 mt-10">
            <h3 className="relative right-6 bottom-6 bg-gradient-to-r rounded-xl p-1 from-cyan-500 to-blue-500 text-white text-center">Teams</h3>
            {addParticipantSlots()}
          </div>
        </div>
      )
    )
  } else {
    return (
      <div className="mt-48">No games available currently</div>
    )
  }
}

export default Phase1;
